import styled from 'styled-components'
import { orange, blue, textMuted, lightGrey, grey, surface2, border1 } from '@/theme/colors'
import { radii, motion, layers } from '@/theme/tokens'
import { fontSizes } from '@/theme/typography'
import { Pill } from '@components/Pill'

/**
 * The link-preview and tag styling for an idea's detail view. Lives at the
 * Ideas module root (not inside a component folder) because both the member
 * edit surface and the public read-only idea popup render the same rows.
 */
export const CardLinks = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	cursor: default;
	pointer-events: auto;
	position: relative;
	z-index: ${layers.raised};
`

export const LinkPreviewCard = styled.a<{ $clickable?: boolean }>`
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 8px;
	border: 1px solid ${border1};
	border-radius: ${radii.small};
	background: ${surface2};
	text-decoration: none;
	transition: all ${motion.base};
	cursor: ${({ $clickable }) => ($clickable === false ? 'default' : 'pointer')};
	overflow: hidden;

	&:hover {
		background: ${grey};
		border-color: ${orange};
		transform: translateX(2px);
	}
`

export const LinkThumbnail = styled.div<{ src?: string }>`
	width: 60px;
	height: 60px;
	min-width: 60px;
	border-radius: ${radii.small};
	background: ${props => (props.src ? `url(${props.src})` : lightGrey)};
	background-size: cover;
	background-position: center;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
`

export const LinkInfo = styled.div`
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 4px;
`

export const LinkSource = styled.div<{ $color?: string }>`
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: ${fontSizes.micro};
	font-weight: 700;
	color: ${({ $color }) => $color ?? textMuted};
	text-transform: capitalize;
`

export const LinkUrl = styled.div`
	font-size: ${fontSizes.caption};
	color: ${blue};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`

export const CardTags = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
	margin-top: 12px;
`

export const Tag = styled(Pill).attrs({ $tone: 'muted' as const })``
